
import React from "react";

interface EmptyStateProps {
  hasReports: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ hasReports }) => {
  if (hasReports) {
    return (
      <div className="text-center text-gray-500 my-12">
        ไม่พบรายงานที่ตรงกับเงื่อนไขการค้นหา
      </div>
    );
  }
  
  return (
    <div className="text-center text-gray-500 my-12">
      ไม่พบรายงานที่ต้องตรวจ worksheet
    </div>
  );
};
